// Report-card remarks (exam.md 9.1 kinds 5/6/7) and the per-student values of
// the report-card extra parameters (exam.md 7.3, level 5).
//
// All of them hang off one `mutli_exam_reportcard_teacher_remarks` container
// row keyed by (student_id, sorted CSV of exam-type ids), which is why every
// call carries `exam_type_ids` rather than a container id.
export const GET_EXAM_REMARKS_SHEET = 'GET_EXAM_REMARKS_SHEET'
export const SAVE_EXAM_REMARKS_SUBJECT = 'SAVE_EXAM_REMARKS_SUBJECT'
export const SAVE_EXAM_REMARKS_SUBSECTION = 'SAVE_EXAM_REMARKS_SUBSECTION'
